import { SELECTION_STATE } from './utils/constants.js';
import './CandidateCard.css';

/**
 * CandidateCard - Display a single candidate with image and name
 * @param {Object} props
 * @param {Object} props.candidate - Candidate object {id, name, nameEn, img}
 * @param {Function} props.onClick - Click handler
 * @param {string} props.selectionState - IDLE, WINNER, or LOSER
 * @param {boolean} props.disabled - Whether the card is clickable
 * @param {string} props.language - Language code ('ko' or 'en')
 */
export default function CandidateCard({
  candidate,
  onClick,
  selectionState = SELECTION_STATE.IDLE,
  disabled = false,
  language = 'ko',
}) {
  const handleClick = () => {
    if (!disabled && selectionState === SELECTION_STATE.IDLE) {
      onClick(candidate);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      handleClick();
    }
  };

  const displayName = language === 'en' ? candidate.nameEn || candidate.name : candidate.name;

  const classNames = [
    'candidate-card',
    selectionState === SELECTION_STATE.WINNER && 'candidate-card--winner',
    selectionState === SELECTION_STATE.LOSER && 'candidate-card--loser',
    disabled && 'candidate-card--disabled',
    'bg-[#EF4646]'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      className={classNames}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      disabled={disabled}
      type="button"
      aria-label={`${displayName} ${language === 'ko' ? '선택' : 'Select'}`}
    >
      <div className="candidate-card__image-wrapper">
        <img
          src={candidate.img}
          alt={displayName}
          className="candidate-card__image"
          loading="lazy"
        />
      </div>
      <div className="candidate-card__content">
        <h3 className="candidate-card__name">{displayName}</h3>
      </div>
    </button>
  );
}